import { ReminderTargetType } from './../../../../assets/enum/reminderTargetTypeEnum';
import {
  Component,
  EventEmitter,
  inject,
  Inject,
  Output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
  MatDialogContent,
  MatDialogClose,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {
  MatError,
  MatFormField,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CustomReminderService } from '../../../features/custom-reminder/services/custom-reminder.service';
import { ReminderChannelEnum } from '../../../../assets/enum/reminderChannelEnum';
import { ReminderPriorityEnum } from '../../../../assets/enum/reminderPriorityEnum';
import { ReminderStatusEnum } from '../../../../assets/enum/reminderStatusEnum';
import { ConfirmDialog } from '../confirm-dialog/confirm-dialog';
import { Subject } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ProjectService } from '../../../features/projects/services/projects.service';
import { CustomerService } from '../../../features/customers/services/customer.service';
import { VendorInvoiceService } from '../../../features/vendor-invoice/services/vendor-invoice.service';
import { QuotationService } from '../../../features/quotation/services/quotation.service';
import { TasksService } from '../../../features/tasks/services/tasks.service';
import { InvoiceService } from '../../../features/invoice/services/invoice.service';

@Component({
  selector: 'app-side-popup',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, CommonModule],
  templateUrl: './side-popup.component.html',
  styleUrl: './side-popup.component.scss',
})
export class SidePopupComponent {
  readonly panelOpenState = signal(false);
  readonly dialog = inject(MatDialog);
  @Output() closeSidebar = new EventEmitter<void>();
  search: string = '';
  customReminders: any[] = [];
  constructor(
    private reminderService: CustomReminderService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.fetchCustomReminders();
  }
  close() {
    this.closeSidebar.emit();
  }

  onDeleteReminder(reminderId: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteReminder(reminderId);
      }
    });
  }

  deleteReminder(id: number) {
    this.reminderService.removeCustomReminder(id).subscribe({
      next: (data) => {
        this.toastr.success('Reminder deleted successfully!', 'Success');
        this.fetchCustomReminders();
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }

  openReminderModal(id?: number) {
    if (id) {
      const dialogRef = this.dialog.open(CustomReminderNewDialog, {
        data: {
          id: id,
        },
        width: '90vw',
        height: '90vh',
      });
    } else {
      const dialogRef = this.dialog.open(CustomReminderNewDialog, {
        width: '90vw',
        height: '90vh',
      });
    }
  }

  fetchCustomReminders() {
    const filter = {
      search: this.search,
    };
    this.reminderService.customReminders(filter).subscribe({
      next: (data) => {
        console.log('data', data);
        this.customReminders = data;
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }
}

@Component({
  selector: 'app-custom-reminder-new',
  templateUrl: './custom-reminder-new.html',
  styleUrls: ['./side-popup.component.scss'],
  standalone: true,
  imports: [
    MatDialogContent,
    MatButtonModule,
    MatDialogClose,
    ReactiveFormsModule,
    FormsModule,
    MatError,
    MatFormField,
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
  ],
})
export class CustomReminderNewDialog {
  createReminderForm: FormGroup;
  dueAtValue: any;
  startAtValue: any;
  endAtValue: any;
  targetValues: any;
  targetType: ReminderTargetType[] = Object.values(ReminderTargetType);
  channelType: ReminderChannelEnum[] = Object.values(ReminderChannelEnum);
  priorityType: ReminderPriorityEnum[] = Object.values(ReminderPriorityEnum);
  statusType: ReminderStatusEnum[] = Object.values(ReminderStatusEnum);
  reminderType = ['OneTime', 'Recurring'];
  reminderId: number;
  reminderData: any;
  dueAtValues: any;
  startAtValues: any;
  endAtValues: any;
  private searchSubject = new Subject<string>();
  search: any;
  page = 0;
  minDate: Date = new Date();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<CustomReminderNewDialog>,
    private fb: FormBuilder,
    private reminderService: CustomReminderService,
    private projectService: ProjectService,
    private customerService: CustomerService,
    private vendorInvoiceService: VendorInvoiceService,
    private quoteService: QuotationService,
    private taskService: TasksService,
    private invoiceService: InvoiceService, 
  ) {}
  ngOnInit() {
    if (this.data) {
      this.reminderId = this.data.id;
      this.fetchReminder(this.reminderId);
    }
    this.initform();
    this.createReminderForm
      .get('reminderType')
      ?.valueChanges.subscribe((value) => {
        if (value === 'OneTime') {
          this.createReminderForm
            .get('dueAtDate')
            ?.setValidators([Validators.required]);
          this.createReminderForm
            .get('dueAtTime')
            ?.setValidators([Validators.required]);

          this.createReminderForm.get('startAtDate')?.clearValidators();
          this.createReminderForm.get('startAtTime')?.clearValidators();
          this.createReminderForm.get('endAtDate')?.clearValidators();
          this.createReminderForm.get('endAtTime')?.clearValidators();
        } else if (value === 'Recurring') {
          this.createReminderForm
            .get('startAtDate')
            ?.setValidators([Validators.required]);
          this.createReminderForm
            .get('startAtTime')
            ?.setValidators([Validators.required]);
          this.createReminderForm
            .get('endAtDate')
            ?.setValidators([Validators.required]);
          this.createReminderForm
            .get('endAtTime')
            ?.setValidators([Validators.required]);

          this.createReminderForm.get('dueAtDate')?.clearValidators();
          this.createReminderForm.get('dueAtTime')?.clearValidators();
        } else {
          // Clear all conditional validators for safety
          [
            'dueAtDate',
            'dueAtTime',
            'startAtDate',
            'startAtTime',
            'endAtDate',
            'endAtTime',
          ].forEach((field) => {
            this.createReminderForm.get(field)?.clearValidators();
          });
        }

        // Update validity on all involved controls
        [
          'dueAtDate',
          'dueAtTime',
          'startAtDate',
          'startAtTime',
          'endAtDate',
          'endAtTime',
        ].forEach((field) => {
          this.createReminderForm.get(field)?.updateValueAndValidity();
        });
      });
    this.createReminderForm
      .get('targetType')!
      .valueChanges.subscribe((type: string) => {
        if (type) {
          this.fetchTargetTypeData(type);
        }
      });
  }
  onClose() {
    this.dialogRef.close();
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  loadEmployeeTypeData() {
    this.projectService.getAllEmployees('').subscribe({
      next: (employeeTypes) => {
        this.targetValues = employeeTypes;
      },
      error: (error) => console.error('Error fetching employee types:', error),
    });
  }

  private fetchPartners() {
    this.customerService.fetchCustomers(this.search).subscribe({
      next: (partners: any) => {
        this.targetValues = partners;
      },
      error: (error) => console.error(error),
    });
  }

  getVendors() {
    this.vendorInvoiceService.fetchVendors(this.search).subscribe({
      next: (data) => {
        this.targetValues = data;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getLeadDropdown(): void {
    this.quoteService.leadsDropDown(this.search).subscribe({
      next: (data) => {
        this.targetValues = data;
      },
    });
  }

  private fetchTasks() {
    this.taskService.fetchTasks(this.search).subscribe({
      next: (tasks: any) => {
        this.targetValues = tasks;
      },
      error: (error: any) => {
        this.toastr.error(error, 'Error');
      },
    });
  }

  fetchQuotations(pageSize: number = 10
  ) {
    const skip = this.page * pageSize;
    const input = {
      search: this.search,
      limit: pageSize,
      skip,
    }
    this.quoteService
      .findAllQuotessWithPagination(input)
      .subscribe({
        next: (quotes) => {  
          this.targetValues = quotes?.quotes
        },
        error: (err) => {
          console.error('Error fetching journals:', err);
        }
      });
  }

  private fetchAllProjects(pageSize: number = 10) {    
    const skip = this.page * pageSize;
    const input = {
      search: this.search,
      limit: pageSize,
      skip,
    }
    this.projectService
      .findAllProjectsWithPagination(input)
      .subscribe({
        next: (projects: any) => {
          this.targetValues = projects?.projects
        },
        error: (error: any) => {
          this.toastr.error(error, 'Error');
        },
      });
  }

  getAllInvoices(pageSize: number = 10) {
    const skip = this.page * pageSize;
    const input = {
      limit: pageSize,
      skip: skip,
      search: this.search,
    };
    this.invoiceService
      .getAllInvoicesWithPagination(input)
      .subscribe({
        next: (data) => {
          this.targetValues = data?.invoices
        },
        error: (error: any) => {
          this.toastr.error(error, 'Error');
        },
      });
  }

  fetchTargetTypeData(type: string) {
    switch (type) {
      case 'User':
        this.loadEmployeeTypeData();
        break;
      case 'Customer':
        this.fetchPartners();
        break;
      case 'Vendor':
        this.getVendors();
        break;
      case 'Lead':
        this.getLeadDropdown();
        break;
      case 'Task':
        this.fetchTasks();
        break;
      case 'Quote':
        this.fetchQuotations();
        break;
      case 'Project':
        this.fetchAllProjects();
        break;
      case 'Invoice':
        this.getAllInvoices();
        break;
      default:
        break;
    }
  }

  splitIsoToDateTime(timestamp: string): { date: string; time: string } {
    if (!timestamp || isNaN(Number(timestamp))) {
      return { date: '', time: '' }; // Invalid input gracefully handled
    }

    const dateObj = new Date(Number(timestamp));

    const date = dateObj.toLocaleDateString('en-IN');
    const time = dateObj.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
    });
    console.log('date', date, 'time', time);
    return { date, time };
  }

  initform() {
    this.createReminderForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      targetType: ['', Validators.required],
      targetId: ['', Validators.required],
      channel: ['', Validators.required],
      priority: ['', Validators.required],
      reminderType: ['', Validators.required],
      dueAtDate: ['', Validators.required],
      dueAtTime: ['', Validators.required],
      startAtDate: ['', Validators.required],
      startAtTime: ['', Validators.required],
      endAtDate: ['', Validators.required],
      endAtTime: ['', Validators.required],
      reminderStatus: ['', Validators.required],
    });
  }

  combineDateTimeWithOffset(
    dateControl: string,
    timeControl: string
  ): string | null {
    const dateVal: Date = this.createReminderForm.get(dateControl)?.value;
    const timeVal: string = this.createReminderForm.get(timeControl)?.value; // expects "HH:mm" format

    if (!dateVal || !timeVal) return null;
    console.log('dateVal', dateVal, 'timeVal', timeVal);

    // Extract hours and minutes from time string
    const [hours, minutes] = timeVal.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return null;

    // Create a new Date object based on the date input
    const combinedDate = new Date(dateVal);
    combinedDate.setHours(hours, minutes, 0, 0);

    // Format date parts with leading zeros
    const pad = (num: number) => String(num).padStart(2, '0');
    const year = combinedDate.getFullYear();
    const month = pad(combinedDate.getMonth() + 1);
    const day = pad(combinedDate.getDate());
    const hour = pad(combinedDate.getHours());
    const minute = pad(combinedDate.getMinutes());
    const second = '00';
    const offsetMinutes = 330;
    // Calculate timezone offset sign and format
    const sign = offsetMinutes >= 0 ? '+' : '-';
    const absOffset = Math.abs(offsetMinutes);
    const offsetHour = pad(Math.floor(absOffset / 60));
    const offsetMinute = pad(absOffset % 60);

    // Construct ISO 8601 string with offset
    return `${year}-${month}-${day}T${hour}:${minute}:${second}${sign}${offsetHour}:${offsetMinute}`;
  }

  onSave() {
    if (this.createReminderForm.invalid) {
      this.createReminderForm.markAllAsTouched();
      console.log('Form is invalid');
      return;
    }
    const formValue = this.createReminderForm.value;
    console.log('formValue', formValue);
    if (this.createReminderForm.get('reminderType')?.value === 'Recurring') {
      this.startAtValue = this.combineDateTimeWithOffset('startAtDate','startAtTime');
      this.endAtValue = this.combineDateTimeWithOffset('endAtDate','endAtTime');
      this.dueAtValue = null;
    } else if (
      this.createReminderForm.get('reminderType')?.value === 'OneTime'
    ) {
      this.dueAtValue = this.combineDateTimeWithOffset('dueAtDate','dueAtTime');
      this.startAtValue = null;
      this.endAtValue = null;
    }
    console.log('this.dueAtValue', this.dueAtValue);
    console.log('this.startAtValue', this.startAtValue);
    console.log('this.endAtValue', this.endAtValue);
    let payload = {
      title:formValue.title,
      description:formValue.description,
      targetType: formValue.targetType,
      targetId: formValue.targetId,
      channel:formValue.channel,
      priority:formValue.priority,
      reminderType: formValue.reminderType,
      reminderStatus:formValue.reminderStatus,
      dueAt: this.dueAtValue,
      startAt: this.startAtValue,
      endAt: this.endAtValue,
    };
    const updatePayload = {
      ...payload,
      id:this.reminderId
    }
    if(this.reminderId){
      this.reminderService.updateCustomReminder(this.reminderId,updatePayload).subscribe({
        next:(data) => {
          this.toastr.success('Reminder updated successfully!', 'Success');
          this.dialogRef.close();
        },
        error:(error) => {
          console.log("error",error);
        }
      })
    }else{
      this.reminderService.createCustomReminder(payload).subscribe({
      next:(data) => {  
        this.toastr.success('Reminder created successfully!', 'Success');
        this.dialogRef.close();
      },
      error:(error) => {
        console.log("error",error);
      }
    })
    }
    
  }

  populateForm() {
    this.createReminderForm.patchValue({
      title: this.reminderData.title,
      description: this.reminderData.description,
      targetType: this.reminderData.targetType,
      targetId: this.reminderData.targetId,
      channel: this.reminderData.channel,
      priority: this.reminderData.priority,
      reminderType: this.reminderData.reminderType,
      dueAtDate: this.parseDateString(this.dueAtValues.date),
      dueAtTime: this.convertTo24Hour(this.dueAtValues.time),
      startAtDate: this.parseDateString(this.startAtValues.date),
      startAtTime: this.convertTo24Hour(this.startAtValues.time),
      endAtDate: this.parseDateString(this.endAtValues.date),
      endAtTime: this.convertTo24Hour(this.endAtValues.time),
      reminderStatus: this.reminderData.reminderStatus,
      status: this.reminderData.status,
    });
  }

  fetchReminder(id: number) {
    this.reminderService.customReminder(id).subscribe({
      next: (data) => {
        console.log('reminderdata', data);
        this.reminderData = data;
        console.log('this.reminderData.due', this.reminderData.dueAt);
        console.log('this.reminderData.startAt', this.reminderData.startAt);
        console.log('this.reminderData.endAt', this.reminderData.endAt);

        this.dueAtValues = this.splitIsoToDateTime(this.reminderData.dueAt);
        this.startAtValues = this.splitIsoToDateTime(this.reminderData.startAt);
        this.endAtValues = this.splitIsoToDateTime(this.reminderData.endAt);
        console.log('this.dueAtValues', this.dueAtValues);
        console.log('this.startAtValues', this.startAtValues);
        console.log('this.endAtValues', this.endAtValues);
        this.populateForm();
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }

  parseDateString(dateStr: string): Date | null {
    if (!dateStr) return null;

    // Parse assuming "dd/MM/yyyy" format (adjust as per your locale)
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;

    const day = Number(parts[0]);
    const month = Number(parts[1]) - 1; // JS months 0-based
    const year = Number(parts[2]);

    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;

    return new Date(year, month, day);
  }

  convertTo24Hour(timeStr: string): string {
    // Example: "12:29 PM" -> "12:29", "1:05 AM" -> "01:05"
    if (!timeStr) return '';

    // If timeStr already in "HH:mm" format, return as is
    if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr;

    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (modifier.toLowerCase() === 'pm' && hours < 12) hours += 12;
    if (modifier.toLowerCase() === 'am' && hours === 12) hours = 0;

    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');
    return `${hh}:${mm}`;
  }

  onCancel() {
    this.createReminderForm.reset();
  }
}
